export const CONCURRENT_USERS_REQUIRED = 'Seats is a required field';
